
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/terms/legal",
      function () {
        return require("private-next-pages/profile/terms/legal.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/terms/legal"])
      });
    }
  